import cCopyLine from '#themes/default/default/components/copyLine/copyLine.js';
import cInfoBox from '#themes/default/default/components/infoBox/infoBox.js';
import cInstructionStep from '#themes/default/default/components/instructionStep/instructionStep.js';
import cOfflineContentBox from '#themes/default/default/components/offlineContentBox/offlineContentBox.js';
import cQrCode from '#themes/default/default/components/qrCode/qrCode.js';

import template from './wireTransferInstructions.html' with { type: 'html' };

export default {
	name: 'CWireTransferInstructions',
	components: {
		cCopyLine,
		cInfoBox,
		cInstructionStep,
		cOfflineContentBox,
		cQrCode
	},
	props: {
		order: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			showQrCode: false
		};
	},
	template
};
